import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface NavigationContext {
  type: "MyClimateAction" | "Workspace" | "Team" | "FocusArea" | "Project";
  id: string;
}

type ClimateActionNavigationStore = {
  climateActionIdList: string[];
  setClimateActionIdList: (climateActionIdList: string[]) => void;
  navigationContext: NavigationContext | null;
  setNavigationContext: (navigationContext: NavigationContext | null) => void;
};

export const useClimateActionNavigationStore = create<ClimateActionNavigationStore>()(
  persist(
    (set) => ({
      climateActionIdList: [],
      setClimateActionIdList: (climateActionIdList: string[]) => {
        set((state) => ({
          ...state,
          climateActionIdList,
        }));
      },
      navigationContext: {
        type: "Workspace",
        id: "",
      },
      setNavigationContext: (navigationContext: NavigationContext | null) => {
        set((state) => ({
          ...state,
          navigationContext,
        }));
      },
    }),
    {
      name: "climate-action-navigation", // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export const getClimateActionNavigationPath = (navigationContext: NavigationContext | null): string => {
  if (!navigationContext) return "climate-actions";

  switch (navigationContext.type) {
    case "MyClimateAction":
      return "my-climate-actions";
    case "Team":
      return "teams";
    case "Project":
      return "projects";
    default:
      return "climate-actions";
  }
};
